import React, { createContext, useState, useContext, useCallback } from 'react';

export const SideNavContext = createContext();

export const SideNavContextProvider = ({ children }) => {

  const [page, setPage] = useState(null);
  const [visible, setVisibility] = useState(false);
  const [maximized, setMaximized] = useState(true);

  return (
    <SideNavContext.Provider value={{ setPage, page, visible, setVisibility, maximized, setMaximized }}>
      {children}
    </SideNavContext.Provider>
  );


};

export const useSideNavContext = () => useContext(SideNavContext);
